import { fmhNpiAPI, REFERENCE_API_URL } from 'api/APIBase';

/** Gets reference information about a list of prescribers based on NPI */
export async function getPrescriberInfo(selectedNpi) {
    const url = `${REFERENCE_API_URL}/prescribers`;
    return fmhNpiAPI({ url })
        .query({ npis: [selectedNpi] })
        .get()
        .json();
}

/** Gets the list of payers */
export async function getPayers() {
    const url = `${REFERENCE_API_URL}/payers/`;
    return fmhNpiAPI({ url }).get().json();
}

/** Get the referent code for a product service OID */
export async function getReferentCode(productServiceOid, billingType) {
    const url = `${REFERENCE_API_URL}/productservices/${productServiceOid}/codes/referent`;
    return fmhNpiAPI({ url }).query({ billing_type: billingType }).get().json();
}

/** Gets the list of medications */
export async function getMedications(segmentId) {
    const url = `${REFERENCE_API_URL}/product_benefit_configs/segments/${segmentId}`;
    return fmhNpiAPI({ url }).get().json();
}

/** Gets the list of diagnoses */
export async function getDiagnoses() {
    const url = `${REFERENCE_API_URL}/diagnoses/`;
    return fmhNpiAPI({ url }).get().json();
}

/** Gets the list of parent suppliers */
export async function getParentSuppliers() {
    const url = `${REFERENCE_API_URL}/suppliers/parents`;
    return fmhNpiAPI({ url }).get().json();
}

/** Gets the information about a supplier based on supplier NPI */
export async function getSupplierInfo(supplierNpi) {
    const url = `${REFERENCE_API_URL}/suppliers/${supplierNpi}`;
    return fmhNpiAPI({ url })
        .get()
        .notFound(() => ({}))
        .json();
}

export async function getPlacesOfService() {
    const url = `${REFERENCE_API_URL}/product_benefit_configs/places`;
    return fmhNpiAPI({ url }).get().json();
}

/** Gets list of pharmacies eligible to participate in a marketplace event. */
export async function getEligibleSuppliers({
    payerId,
    segmentId,
    memberState,
    productServiceOid,
    benefit,
    placeOfService,
}) {
    const url = `${REFERENCE_API_URL}/eligible_suppliers/`;
    return fmhNpiAPI({ url })
        .query({
            payer_id: payerId,
            segment_id: segmentId,
            member_state: memberState,
            product_service_oid: productServiceOid,
            place_of_service: placeOfService,
            benefit,
        })
        .get()
        .notFound(() => [])
        .json();
}
